<template>
    <div>
        <!-- <a-collapse class="collapse" :default-active-key="['1']" accordion :onChange="onChange">
            <a-collapse-item :header="$t('base.search')" key="1">
                <Form :form="queryForm" @handleSelectChange="handleSelectChange">
                    <template v-slot:formBtn>
                        <a-button class="form_btn" type="primary" @click="handle('search')">{{ $t('base.search') }}</a-button>
                        <a-button class="form_btn" type="outline" @click="handle('reset')">{{ $t('base.reset') }}</a-button>
                    </template>
                </Form>
            </a-collapse-item>
        </a-collapse> -->

        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form 
                    :form="queryForm" 
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <!-- <a-button class="form_btn" type="primary" size="mini" @click="handle('search')">{{ $t('base.search') }}</a-button>
                <a-button class="form_btn" type="outline" size="mini" @click="handle('reset')">{{ $t('base.reset') }}</a-button> -->

                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div>

        <Table 
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <!-- 自定义字段 -->
            <template v-slot:editLogStatus="{ props }">
                <a-tag color="red">{{ props.record.status }}</a-tag>
            </template>
       
            <!-- 子表格操作 -->
            <!-- <template v-slot:tableOperate="{ props }">
                <a-button type="text" :disabled="props.record.disabled" size="small"  @click="handle('edit',props.record)"><icon-edit /></a-button>
                <a-divider direction="vertical" />
                <a-button type="text" status="danger" size="small" :disabled="props.record.disabled" @click="handle('delete',props.record)"><icon-delete /></a-button>
            </template> -->
        </Table>
    </div>
</template>

<script setup>
    import { onMounted, reactive, ref, watch, nextTick } from 'vue';
    import { LogApi } from '@/api/LogApi.js';
    import { StockOutApi } from '@/api/StockOutApi.js';
    import { Message } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { ErrorLogQuery } from './queryConfig/ErrorLogQuery.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { dateToTimestamp, timestampToDate } from '@/utils/index.js';

    const localeStore = useLocale()

    const { t } = useI18n()

    const showForm = ref(false)
    const queryForm = reactive(ErrorLogQuery)
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
                fixed:'left',
                align:'center',
            },
            // {
            //     // title: '订单编号',
            //     title: t('log.orderNo'),
            //     dataIndex: 'orderNo',
            //     key:'orderNo',
            //     width:'140',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'center',
            // },
            {
                // title: '客户名称',
                title: t('log.orderName'),
                dataIndex: 'orderName',
                key:'orderName',
                width:'120',
                ellipsis:true,
                tooltip:true,  
                align:'center',
            },
            {
                // title: 'sku',
                title: t('log.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'150',
                ellipsis:true,
                tooltip:true,  
                align:'center',
            },
            {
                // title: '订单来源',
                title: t('log.source'),
                dataIndex: 'source',
                key:'source',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
            {
                // title: '物料编码',
                title: t('log.inventoryCode'),
                dataIndex: 'inventoryCode',
                key:'inventoryCode',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
            {
                // title: '状态',
                title: t('log.status'),
                dataIndex: 'status',
                key:'status',
                width:'100',
                ellipsis:true,
                tooltip:true,
                align:'center',
                slotName:'log_status'
            },
            {
                // title: '报错描述',
                title: t('log.message'),
                dataIndex: 'message',
                key:'message',
                width:'630',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
            {
                // title: '类别',
                title: t('log.syncType'),
                dataIndex: 'syncType',
                key:'syncType',
                width:'130',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
            {
                // title: '同步日期',
                title: t('log.syncTimestamp'),
                dataIndex: 'syncTimestamp',
                key:'syncTimestamp',
                width:'160',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
            // {
            //     // title: '创建日期',
            //     title: t('log.createDate'),
            //     dataIndex: 'createDate',
            //     key:'createDate',
            //     width:'160',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'center',
            // },
            // {
            //     // title: '更新日期',
            //     title: t('log.updateDate'),
            //     dataIndex: 'updateDate',
            //     key:'updateDate',
            //     width:'160',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'center',
            // },
        ],
        configs:{
            scroll:{
                x:1000,
                y:480,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                size:'mini',
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
            
        },
    })

    const orderSource = ref({
        1:'Shopify',
        3:'JobRad',
        4:'Bikeexchange',
        5:'Amazon-seller',
        6:'Amazon-vender', 
        7:'Decathlon',
        8:'Ebay',
        9:'Newbiker GmbH',
        10:'Factory',
        11:'Off-line dealers',
        12:'HANN-BIKES',
        13:'Hupfer GmbH',
        14:'Zwoo GmbH',
        15:'Alltricks',
        16:'Radl Ladl',
        17:'Schnellrad by Zweirad Schnell UG',
    })

    const showFormPanel = (val)=>{
        showForm.value = val
    }

    const handle = (type,row)=>{
        switch(type){
            case 'search':
                table.value.configs.pagination.current = 1
                getLogList()
                break;
            case 'reset':
                queryForm.formField.forEach(item=>{
                    queryForm.formData[item.key] = ''
                })
                table.value.configs.pagination.current = 1
                getLogList()
                break;
        }
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getLogList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getLogList()
    }

    // 列表查询-select
    const handleSelectChange = (val,opt,key)=>{
        console.log(val,opt,key,'val,opt,key')
        queryForm.formData[key] = val
        table.value.configs.pagination.current = 1
        getLogList()
    }

    // 列表查询-input
    const handleInputClear = (item, val)=>{
        table.value.configs.pagination.current = 1
        getLogList()
    }
    const handlePressEnter = (val,item)=>{
        table.value.configs.pagination.current = 1
        getLogList()
    }

    // 获取日志列表
    const getLogList = async ()=>{
        let param = {
            ...queryForm.formData,
            orderName:queryForm.formData.orderName.trim(),
            sku:queryForm.formData.sku.trim(),
            inventoryCode:queryForm.formData.inventoryCode.trim()
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await LogApi.getInstance().getLogList(param, page_num, page_size)
        if(res.code == 0){
            table.value.datas = []
            res.data.records.length > 0 && res.data.records.forEach((item,index)=>{
                table.value.datas.push({
                    ...item,
                    No: index + 1,
                    sku: item.sku == '' || item.sku == undefined? '-' : item.sku,
                    inventoryCode: item.inventoryCode == undefined? '-' : item.inventoryCode,
                    updateDate: item.updateDate == undefined? '-' : item.updateDate,
                    status:item.status == 'E'? t('log.error') : t('log.success'),
                    source:orderSource.value[item.source],
                    syncTimestamp: item.syncTimestamp == undefined? '-' : timestampToDate(item.syncTimestamp)
                })
            })
            table.value.configs.pagination.total = res.data.total
            table.value.configs.pagination.current = res.data.current
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取订单来源类型 和 erp客户编码
    const getOrderSource = async ()=>{
        let res = await LogApi.getInstance().getOrderSource({status:'A'})
        if(res.code == 0){
            let queryFormItem = queryForm.formField.find(i=> i.key == 'source')
            queryFormItem.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                queryFormItem.options.push({
                    label: i.id == '1'? 'Shopify' : i.customer_name,
                    value:i.id, // 来源类型
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

     // 获取产品列表,拿到SKU和物料编码下拉数据
     const getSkuAndInventoryCodeList = async ()=>{
        let res = await StockOutApi.getInstance().getProductList({simple_flag:1})
        if(res.code == 0){
            let item = queryForm.formField.find(i=>i.key == 'sku')
            let item2 = queryForm.formField.find(i=>i.key == 'inventoryCode')
            item.options = []
            item2.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.sku,
                    value:i.sku
                })
                item2.options.push({
                    label:i.inventory_code,
                    value:i.inventory_code
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 处理查询面板伸缩时表格高度
    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        const searchContentDomHeight = document.querySelector('.queryPanel').clientHeight
        const pageHeight = 50
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight - pageHeight - footerHeight - 60
    }

    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })

    onMounted(()=>{
        getLogList()
        getOrderSource()
        getSkuAndInventoryCodeList()

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })
    })

</script>

<style lang="less" scoped>
// .collapse{
//     margin-bottom: 10px;
//     /deep/ .arco-collapse-item-content{
//         background-color: #fff;
//     }

//     .form_btn{
//         margin: 0 10px;
//     }
// }

.queryPanel{
    display: flex;
    margin-bottom:7px;
    padding:7px;
    background: #fff;

    .queryPanel_form{
        display: flex;
        flex:6;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        // flex-direction: column;
        // flex-wrap:wrap;
        flex: 1;
        align-items: center;
        justify-content: center;
        border-left:1px solid #eee;
        padding-left:10px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    /deep/ .arco-form-item-layout-inline{
        margin-right: 0;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:90px;
    }
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    // padding: 10px 0;
    font-size: 13px;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 10px 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}

.addForm{
    /deep/ .arco-input-wrapper,
    /deep/ .arco-picker-size-medium{
        height: 45px;
    }

    /deep/ .arco-form-item-label-col{
        line-height: 45px;
    }
}

</style>